import type { HandleDefinition } from '../types';
import type { StartConfig } from '@legacy-shared/widgets/core/start';
import {
  isOfficeClosedConfigured,
  isZeroPressedConfigured,
  startActionOutputs,
} from '@legacy-shared/flow/start-output';

export function getStartOutputs(config: StartConfig): HandleDefinition[] {
  const outputs: HandleDefinition[] = config.enableCallerIdMatch
    ? [
        { id: 'callerIdNoMatch', type: 'nomatch', label: 'No Match', position: 'bottom' },
        { id: 'callerIdMatch', type: 'success', label: 'Match', position: 'bottom' },
      ]
    : [{ id: 'out', type: 'default', label: 'Next', position: 'bottom' }];

  if (isOfficeClosedConfigured(config)) {
    outputs.push({ id: startActionOutputs.officeClosed, type: 'failure', label: 'Office Closed', position: 'right' });
  }

  if (isZeroPressedConfigured(config)) {
    outputs.push({ id: startActionOutputs.zero, type: 'digit', label: 'Zero', position: 'right' });
  }

  return outputs;
}
